import * as React from "react";
import {Snackbar, Button, SnackbarContent} from "@mui/material";
import {useAtom} from "jotai";
import {activeAuditChangeAtom} from "../atoms/ActiveAuditChange";

const MAX_EXPLANATION_LENGTH = 50;

const truncateText = (text: string, maxLength: number): string => {
   if (text.length <= maxLength) return text;
   return text.substring(0, maxLength) + "...";
};

export const ActiveAuditChangeSnackbar: React.FC = () => {
   const [activeAuditChange, setActiveAuditChange] = useAtom(activeAuditChangeAtom);

   const handleStop = () => {
      setActiveAuditChange(null);
   };

   if (!activeAuditChange) {
      return null;
   }

   const message = `Change in progress: ${truncateText(activeAuditChange.explanation, MAX_EXPLANATION_LENGTH)}`;

   return (
      <Snackbar
         open={true}
         anchorOrigin={{vertical: "bottom", horizontal: "right"}}
      >
         <SnackbarContent
            message={message}
            action={
               <Button
                  color="inherit"
                  size="small"
                  onClick={handleStop}
               >
                  Stop
               </Button>
            }
            sx={{
               backgroundColor: "#000000",
               color: "#FF5376"
            }}
         />
      </Snackbar>
   );
};
